module.exports = __webpack_public_path__ + "static/media/29BDOS22.47778309.jpg";